<template>
  <div class="chat_room_internet_commerce_promotion">
    <div class="chat_table_pro">
      <div class="chat_table_pro_title">
        <img
          :src="require(`@/assets/front/images/v2/logos/logo_lgu_round.svg`)"
          class="logo"
        />
        {{ internetPromotionModel.title }}
      </div>
      <div
        class="chat_table_pro_item"
        v-html="_toBR(internetPromotionModel.contents)"
      ></div>
      <div class="chat_table_pro_txt">프로모션 상담이 시작되었습니다!</div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    internetPromotionModel: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      console.log('valvalvalvalvalval');
      console.log(val);

      var data = String(val)
        .split('\n')
        .join('<br />');

      console.log(data);
      return data;
    },
  },
  methods: {
    _toBR(str) {
      return util.toBR(str);
    },
  },
};
</script>

<style></style>
